import "./MeatAndPoultry.module.css";
import Header from "@/reusable_sections/Header";
import CarnesAvesPrincipios from "./sections/CarnesAvesPrincipios";
import VideoShowcase from "./sections/VideoShowcase";
import Footer from "@/reusable_sections/Footer";
export default function MeatAndPoultryPage() {
  return <div>
      <Header />
      
      <CarnesAvesPrincipios />
      <VideoShowcase />
      <Footer />
    </div>;
}